import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import './styles/login.css';

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const apiAuthUrl = process.env.REACT_APP_API_AUTH_URL

  const handleLogin = async () => {
    try {
      const response = await axios.post(`${apiAuthUrl}/api/auth/login`, {
        username,
        password,
      });
      // ✅ Armazenar APENAS o token (cargo e condominios virão de useAuth hook)
      localStorage.setItem("token", response.data.dados.token);
      window.dispatchEvent(new Event('auth-token-changed'));
      navigate("/home");
    } catch (error) {
      // Se for erro de rate limit, o interceptor já mostrou o alerta
      if (error.isRateLimitError) {
        return;
      }
      // Outros erros: credenciais inválidas, servidor offline, etc
      alert("Credenciais inválidas!");
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1 className="login-logo-text">Automa</h1>
        <h2 className="login-title">Bem-vindo!</h2>
        <div>
          <input
            type="text"
            placeholder="Usuário"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="login-input"
          />
        </div>
        <div>
          <input
            type="password"
            placeholder="Senha"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="login-input"
          />
        </div>
        <button onClick={handleLogin} className="login-button">Login</button>
      </div>
    </div>
  );
};

export default Login;
